import Vue from 'vue';
import VModelMixin from "./vModelMixin";
import {mapMutations, mapState} from "vuex";

export default (fieldName, vuexStateName = 'profile', updateMutationName = 'profileFieldOnInput') => ({
  mixins: [VModelMixin],

  inject: {
    disabledState: {
      default: () => Vue.observable({ disabled: false })
    }
  },

  data() {
    return {
      defaultLabel: null,
      defaultPlaceholder: null,
    }
  },

  props: {
    required: {
      type: Boolean,
      default: false
    },
    label: {
      required: false,
      default: function () {
        return this.defaultLabel
      }
    },
    placeholder: {
      required: false,
      default: function () {
        return this.defaultPlaceholder
      }
    },
  },
  computed: {
    disabled() {
      return this.disabledState.disabled;
    },
    ...mapState([vuexStateName]),
    ...mapState({
      errors: state => {
        const normalizeError = (value) => {
          if (Array.isArray(value)) {
            return value
              .filter(item => item !== null && item !== undefined && item !== '')
              .join(' ');
          }
          return value;
        };

        if (fieldName.startsWith('billing_address.') || fieldName.startsWith('shipping_address.') || fieldName.startsWith('identification.') || fieldName.startsWith('bank_account.')) {
          const fields = fieldName.split('.');
          let iden = state[vuexStateName].errors[fields[0]];
          if (iden && iden.length > 0) {
            return normalizeError(iden[0][fields[1]]);
          }
          return '';
        }

        return normalizeError(state[vuexStateName].errors[fieldName])
      }
    }),
    computedLabel() {
      return this.label || this.defaultLabel
    },
    computedPlaceholder() {
      return this.placeholder || this.defaultPlaceholder
    }
  },
  watch: {
    [`${vuexStateName}.model.${fieldName}`]: {
      immediate: true,
      handler() {
        const fields = fieldName.split('.')
        if (fields.length === 1) {
          this.model = this[vuexStateName].model[fieldName]
        } else {
          this.model = this[vuexStateName].model[fields[0]][fields[1]]
        }
      }
    }
  },
  methods: {
    ...mapMutations([updateMutationName]),
    onInput(val) {
      this[updateMutationName]({field: fieldName, value: val || ''})
    }
  }
})
